import fetch from 'dva/fetch';
import { message } from 'antd';
import { routerRedux } from 'dva/router';

function checkStatus(response) {
  if(response.status === 404) {
    message.error('网络错误，接口404');
  }
  return response;
}

function checkResponse(response) {
  if(response.success == false){
    // 批量处理特殊判断
    if(response.result && response.result.fail && response.result.fail.length > 0){
      return response.result;
    }
    const error = new Error(response.cause);
    error.response = response;
    throw error;
  }else{
    // 解决mock数据格式不统一
    return response.result === undefined ? response : response.result;
  }
}

function dataFormat(response) {
  if(response.headers.get('Content-Type').indexOf('excel') == -1 ){
    return response.json();
  }else{
    return response.blob();
  }
}

/**
 * Requests a URL, returning a promise.
 *
 * @param  {string} url       The URL we want to request
 * @param  {object} [options] The options we want to pass to "fetch"
 * @return {object}           An object containing either "data" or "err"
 */
export default function request(url, options) {
  const defaultOptions = {
    credentials: 'include',
  };
  const www = JSON.parse(sessionStorage.getItem('userInfo'));
  // console.log('www: ',www);
  // if (!www) {
  //   routerRedux.push('/user/login');
  // }
  const defaultBody = www ? {
    userId: (www.userId ? www.userId : null),
    email: (www.email ?  www.email : null),
    accessType: (www.accessType ? www.accessType : null),
    sponsorId: (www.sponsorId ? www.sponsorId : null),
    sponsorName: (www.sponsorName ? www.sponsorName : null),
    sponsorProductName: (www.sponsorProductName ? www.sponsorProductName : null),
    agentId: (www.agentId ? www.agentId : null),
    agentName: (www.agentName ? www.agentName : null),
    operatorId: (www.operatorId ? www.operatorId : null),
    operatorName: (www.operatorName ? www.operatorName : null),
    mediaId: (www.mediaId ? www.mediaId : null),
    mediaName: (www.mediaName ? www.mediaName : null),
    sellerId: (www.sellerId ? www.sellerId : null),
    userInfo: {
      sellerId: www.userInfo ? www.userInfo.sellerId : null,
    },
  } : {sponsorId: null, userId:null, email: null};

  const newOptions = { ...defaultOptions, ...options };

  if (newOptions.method === 'POST' || newOptions.method === 'PUT') {
    newOptions.headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json; charset=utf-8',
      ...newOptions.headers,
    };
    const body = url.endsWith("login") ? {...newOptions.body} : {...newOptions.body, ...defaultBody}
    newOptions.body = JSON.stringify(body);
  }

  return fetch(url, newOptions)
    .then(checkStatus)
    .then(dataFormat)
    .then(checkResponse)
    .catch((error) => {
      if (error.code) {
        message.error(error.message, 5);
      }
      if ('stack' in error && 'message' in error) {
        if (error.response && error.response.redirectLocation) {
          console.log(111, error.response.redirectLocation)
          sessionStorage.setItem('isLoginSponsor', false);
          sessionStorage.removeItem('userInfo')
          sessionStorage.removeItem("loginCondition");
          routerRedux.push(error.response.redirectLocation);
        }
        if (error.response && error.response.resultErrorCode
          && error.response.resultErrorCode === 'NO_ALERT')  {

        } else {
          message.error(error.message, 5);
        }
      }
      return null;
    });
}
